import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './TaskListRow.module.css';
import { useRecoilState } from 'recoil';
import { namespaceState } from '../../recoil/atoms';
import { taskStatusColor } from '../../constants';
import dateFormat from '../../utils/dateFormat';
import useApi from '../../services/useApi';
import ConfirmModal from '../../compoenets/ConfirmModal';
import toUpperFirstCase from '../../utils/toUpperFirstCase';
import ErrorModal from '../../compoenets/ErrorModal';

const CopyBtn = ({ item }) => {
  const [isCopy, setIsCopy] = useState(false);

  const handleCopy = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(id)
      .then(() => {
        setIsCopy(true);
        setTimeout(() => setIsCopy(false), 1500);
      })
      .catch(err => console.error('copy fail:', err));
  };

  return (
    <button
      onClick={(e) => handleCopy(e, item)}
      className={`${styles['btn-copy']} ${isCopy ? styles['btn-copy-done'] : ''}`}
    >
      {isCopy ? "Copy Done" : item.split('-')[0]}
    </button>
  );
};

const Modal = ({ 
  onClose, 
  onDelete, 
  position,
  taskId,
  getTaskList,
  taskState,
  taskUpdatedTime,
  anchorRef,
  onReposition
}) => {
  const [nsState]=useRecoilState(namespaceState);
  const modalRef=useRef(null);

  const handleTaskStop=(e)=>{
    e.stopPropagation();
    useApi.put('ngp/fl/task/'+taskId+'?namespaceId='+nsState.id,'STOP').then(()=>{
      getTaskList(); onClose();
    })
  };
  const handleTaskResume=(e)=>{
    e.stopPropagation();
    useApi.put('ngp/fl/task/'+taskId+'?namespaceId='+nsState.id,'RESUME').then(()=>{
      getTaskList(); onClose();
    })
  };
  const handleTaskDelete=(e)=>{
    e.stopPropagation();
    onDelete(); onClose();
  };

  useEffect(() => {
    const scroller = document.querySelector('[data-scroll-root="true"]');

    const handleOutsideClick = (e) => {
      if (!modalRef.current) return;
      // 앵커(버튼) 클릭은 무시하고, 밖을 클릭하면 닫기
      if (!modalRef.current.contains(e.target)) onClose();
    };

    const closeOnScroll = () => onClose();

    // 윈도우 리사이즈/스크롤, 내부 스크롤, 휠·터치 이동 시 닫기
    window.addEventListener('resize', closeOnScroll, { passive: true });
    window.addEventListener('scroll', closeOnScroll, { passive: true });
    window.addEventListener('wheel', closeOnScroll, { passive: true });
    window.addEventListener('touchmove', closeOnScroll, { passive: true });
    scroller?.addEventListener('scroll', closeOnScroll, { passive: true });
    document.addEventListener('click', handleOutsideClick);

    return () => {
      window.removeEventListener('resize', closeOnScroll);
      window.removeEventListener('scroll', closeOnScroll);
      window.removeEventListener('wheel', closeOnScroll);
      window.removeEventListener('touchmove', closeOnScroll);
      scroller?.removeEventListener('scroll', closeOnScroll);
      document.removeEventListener('click', handleOutsideClick);
    };

}, [onClose]);


  return ReactDOM.createPortal(
    <div
      className={styles['status-modal']}
      style={{ top: position.y, left: position.x }}
      ref={modalRef}
    >
      {!(taskState==="failed"||taskState==="completed"||taskState==="stopped") &&
        <div onClick={handleTaskStop}>
          <span className={`${styles['modal-icon']} ${styles['modal-icon-stop']}`}></span><span>Stop</span>
        </div>
      }
      {(taskState==="failed"||taskState==="stopped")&&(new Date() - dateFormat(taskUpdatedTime).newDate< 86400000) &&
        <div onClick={handleTaskResume}>
          <span className={`${styles['modal-icon']} ${styles['modal-icon-resume']}`}></span><span>Resume</span>
        </div>
      }
      <div onClick={handleTaskDelete}>
        <span className={`${styles['modal-icon']} ${styles['modal-icon-delete']}`}></span><span>Delete</span>
      </div>
    </div>,
    document.body
  )
};

export default function TaskListRow({onClick,data,getTaskList}) {
  const [nsState]=useRecoilState(namespaceState);
  const [statusToggle,setStatusToggle]= useState(false);
  const statusWrapRef=useRef(null);
  const [statusWrapPosition,setStatusWrapPosition] = useState({x:0,y:0});
  const taskState=data.taskState.toLowerCase();
  const [isTest,setIsTest]=useState(false);
  const [nowRound,setNowRound]=useState(0);
  const [isConfirm,setIsConfirm]=useState(false);
  const [isError,setIsError]=useState(false);
  
  useEffect(()=>{
    if(data.numOfTestDevice>0)setIsTest(true);
    if(data.taskState==="COMPLETED"){
      setNowRound(data.currentRoundNum)
    }
    else if(data.taskState==="INIT" || data.taskState==="READY" ){
      setNowRound(0)
    }
    else{
      setNowRound(Math.max(0, data.currentRoundNum-1));
    }
  },[data])

  const handleStatusClick=(e)=>{
    e.stopPropagation();
    setStatusToggle(!statusToggle);
    const statusElement = statusWrapRef.current;
    const statusRect = statusElement.getBoundingClientRect();
    setStatusWrapPosition({ x: statusRect.left, y: statusRect.bottom }); // fixed 기준
  }

  const handleTaskDelete=()=>{
    useApi.delete('ngp/fl/task/'+data.taskId+"?namespaceId="+nsState.id).then(()=>{
      getTaskList(); setIsConfirm(false);
    },()=>{
      setIsConfirm(false); setIsError(true);
    })
  };

  const handleConfirm=()=> setIsConfirm(true);

  return (
    <>
      <div className={styles['grid-row']} onClick={onClick}>
        <div className={`${styles.cell} ${styles['row-id']}`}><CopyBtn item={data.taskId}/></div>
        <div className={`${styles.cell} ${styles['row-name']}`}>{data.taskName}</div>
        <div className={`${styles.cell} ${styles['row-date']}`}>{dateFormat(data.createdTime).date}</div>
        <div className={`${styles.cell} ${styles['row-user']}`}>{data.userMail.replace(/@.*$/,'')}</div>
        <div className={`${styles.cell} ${styles['row-data']}`}>{data.recipe.requiredData}</div>

        <div className={`${styles.cell} ${styles['row-devices']}`}>
          <div className={styles['row-devices-wrap']}>
            <div className={styles['row-devices-item']}>
              <div className={styles['row-rounds-test']}>Train</div>{data.numOfTargetDevice}
            </div>
            <div className={styles['row-devices-item']}>
              <div className={styles['row-rounds-test']}>Test</div>{data.numOfTestDevice}
            </div>
          </div>
        </div>

        <div className={`${styles.cell} ${styles['row-rounds']}`}>
          <div className={styles['row-rounds-wrap']}>
            { data.maxRound!==0
              ? (isTest
                  ? <>{nowRound+"/"+(parseInt(data.maxRound)+1)}<div className={styles['row-rounds-test']}>Test</div></>
                  : `${nowRound}/${data.maxRound}`
                )
              : <div className={styles['row-rounds-test']}>Test Only</div>
            }
          </div>
        </div>

        <div className={`${styles.cell} ${styles['row-status']}`}>
          <div
            ref={statusWrapRef}
            className={`${styles['row-status-wrap']} ${statusToggle ? styles['row-status-wrap-on']:''}`}
            onClick={handleStatusClick}
          >
            <div className={styles['status-body']}>
              <div className={styles['status-dot']} style={{background:taskStatusColor[taskState]}}></div>
              <span className={styles['status-text']}>{toUpperFirstCase(taskState)}</span>
            </div>
            <span className={`${styles['status-arrow']} ${statusToggle ? styles['status-arrow-on']:''}`}>&gt;</span>
          </div>

          {statusToggle&&
            <Modal
              onDelete={handleConfirm}
              onClose={() => setStatusToggle(false)}
              position={statusWrapPosition} 
              taskId={data.taskId}
              taskState={taskState}
              getTaskList={getTaskList}
              taskUpdatedTime={data.updatedTime}
              anchorRef={statusWrapRef}
              onReposition={(pos)=>setStatusWrapPosition(pos)}
            />
          }
        </div>
      </div>

      {isConfirm&&
        <ConfirmModal
          title="Task Delete"
          subTitle={`Task \`${data.taskName}\`을 삭제하겠습니까?`}
          confirmText="Delete"
          cancelText="Cancel"
          onAction={handleTaskDelete}
          onClose={()=>setIsConfirm(false)}
        />
      }
      {isError&&
        <ErrorModal
          title="Permission Denied"
          subTitle={"사용자의 `Task Remove` 권한이 없습니다."}
          onClose={()=>setIsError(false)}
        />
      }
    </>
  );
}
